import { Typography } from "@anchor/react-components/dist/lib/components";
import React, { useEffect, useState, useMemo } from "react";
import { McButton } from "@maersk-global/mds-react-wrapper/components-core";
import { McTable } from "@maersk-global/mds-react-wrapper/components-core/mc-table";
import "./pacr.css";
import PTaskModal from "./PTaskModal";
import UseHandleFileUpload from "../../Utils/UseHandleFileUpload";
import PhotoUploadModal from "../PhotoUploadModal/PhotoUploadModal";
import { useMsal } from "@azure/msal-react";
import { useCallback } from "react";
import { ImageServices } from "../../services/imageServices";

import UserInfo from "../../context/UserAccessContext";
import { IsLocked } from "../IsLocked/IsLocked";
// import { useWebSocket } from "../../context/WebSocketContext/WebSocketContext";

const TAG_BASE =
  "display:inline-block;padding:2px 10px;border-radius:10px;font-size:12px;font-weight:600;white-space:nowrap;line-height:16px;";

const TAG_STYLES = {
  success: `${TAG_BASE}background-color:var(--mds_brand_appearance_success_weak_background-color,#d4edda);color:var(--mds_brand_appearance_success_weak_on-background-color,#155724);`,
  error: `${TAG_BASE}background-color:var(--mds_brand_appearance_error_weak_background-color,#fcdde0);color:var(--mds_brand_appearance_error_weak_on-background-color,#370005);`,
  warning: `${TAG_BASE}background-color:var(--mds_brand_appearance_warning_weak_background-color,#fff3cd);color:var(--mds_brand_appearance_warning_weak_on-background-color,#856404);`,
  neutral: `${TAG_BASE}background-color:var(--mds_brand_appearance_neutral_weakest_background-color,#f7f7f7);color:var(--mds_brand_appearance_neutral_weakest_on-background-color,#616161);`,
};

function getPTaskStatusAppearance(status, eta) {
  const s = status?.toLowerCase();
  if (s === "done" || s === "closed") return "success";
  if (eta) {
    const due = new Date(eta);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (due < today) return "error";
  }
  return "warning";
}

const PTASK_COLUMNS = [
  { id: "ptaskid", label: "PTask ID", noWrap: true },
  { id: "description", label: "Summary" },
  { id: "owners", label: "Assigned To" },
  { id: "assignment_group", label: "Assignment Group" },
  { id: "platformPortfolio", label: "Portfolio" },
  { id: "ptaskPlatform", label: "Platform" },
  { id: "ptaskProduct", label: "Product" },
  { id: "horizontalVerticalFix", label: "Fix Type" },
  {
    id: "status",
    label: "Status",
    noWrap: true,
    cellTemplate: (e) =>
      e.html`<span style="${TAG_STYLES[e.rowData.statusAppearance] || TAG_STYLES.neutral}">${e.rowData.status}</span>`,
  },
  { id: "eta", label: "Due Date", noWrap: true },
];

function PTask({
  contextState,
  pTasks,
  dispatch,
  images,
  imageFormData,
  incidentID,
  currentStep,
  lockedFields,
  changedFields,
  onAutoSave,
}) {
  const { instance, accounts } = useMsal();
  const [pTaskModal, setpTaskModal] = useState(false);
  const [currentpTasks, setCurrentpTasks] = useState(pTasks);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [uploadedPTaskImages, setUploadedPTaskImages] = useState([]);
  const [fetchAgain, setFetchAgain] = useState(false);
  const [loadingImage, setLoadingImage] = useState(false);
  const [errorInFetchingImages, setErrorInFetchingImages] = useState(false);

  const [photosFor, setPhotosFor] = useState("jira");

  const [photoModal, setPhotoModal] = useState(false);
  const [imageToPreview, setImageToPreview] = useState({
    preview: "",
    fileName: "",
  });
  const [previewModal, setPreviewModal] = useState(false);

  // const { sendContentThroughWebSocket, lockField, unlockField } =
  //   useWebSocket();

  const { graphData } = UserInfo();

  const handleFieldLocking = (fieldName) => {
    // lockField(fieldName, graphData.username);
  };

  const handleFieldUnlocking = (fieldName) => {
    // unlockField(fieldName);
  };

  const handleModal = () => {
    handleFieldLocking("ptask");
    setpTaskModal(true);
    // setpTaskModal(!pTaskModal);
  };
  const closeModal = () => {
    handleFieldUnlocking("ptask");
    // setpTaskModal(!pTaskModal);
    setpTaskModal(false);
  };

  const { getImage } = ImageServices();

  useEffect(() => {
    if (!pTaskModal) {
      setCurrentpTasks(pTasks);
    }
  }, [pTaskModal, pTasks]);

  const fetchAndSetImages = useCallback(
    async (setterFunction, tag) => {
      setLoadingImage(true);
      try {
        const images = await getImage([], incidentID, tag);
        setterFunction(images);
        setErrorInFetchingImages(false);
      } catch (error) {
        console.error("Error fetching images:", error);
        setErrorInFetchingImages(true);
      } finally {
        setLoadingImage(false);
      }
    },
    [incidentID, instance, accounts]
  );
  useEffect(() => {
    if (incidentID && currentStep === 2)
      fetchAndSetImages(setUploadedPTaskImages, "ptask");
  }, [incidentID, fetchAgain, fetchAndSetImages]);

  const onSave = () => {
    const hasChanged = JSON.stringify(currentpTasks) !== JSON.stringify(pTasks);
    dispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "PreventiveAndCorrectiveMeasuresState",
      payload: {
        ...contextState,
        pTasks: [...currentpTasks],
      },
    });

    dispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "changedFileds",
      payload: (prevChangedFileds) => ({
        ...prevChangedFileds,
        pTasks: hasChanged ? true : prevChangedFileds.pTasks || false,
      }),
    });

    closeModal();

    if (onAutoSave) {
      setTimeout(() => { onAutoSave(); }, 100);
    }
  };

  const hanldePreviewModal = () => {
    setPreviewModal(!previewModal);
  };

  const handlePhotoModalClick = (fotoFor) => {
    setPhotosFor(fotoFor);
    setPhotoModal(true);
  };
  const handlePhotoModalClose = () => {
    setPhotoModal(false);
  };

  const {
    handleFiles,
    fileChange,

    deleteImage,

    previewImage,
  } = UseHandleFileUpload(
    images,
    setError,
    setErrorMessage,
    photosFor,
    hanldePreviewModal,
    setImageToPreview,
    dispatch,
    imageFormData,
    "preventiveCorrectiveMeasures",
    setFetchAgain,
    incidentID
  );

  const tableData = useMemo(
    () =>
      (pTasks || []).map((ticket, index) => ({
        id: index,
        ptaskid: ticket.ptaskid[0],
        description: ticket.description || "",
        owners:
          typeof ticket.owners === "string"
            ? ticket.owners
            : (ticket.owners || []).join(", "),
        assignment_group: ticket.assignment_group || "",
        platformPortfolio: ticket.platformPortfolio || "",
        ptaskPlatform: ticket.ptaskPlatform || "-",
        ptaskProduct: ticket.ptaskProduct || "-",
        horizontalVerticalFix: ticket.horizontalVerticalFix || "-",
        status: ticket.status || "",
        statusAppearance: getPTaskStatusAppearance(ticket.status, ticket.eta),
        eta: ticket.eta || "",
      })),
    [pTasks]
  );

  return (
    <>
      <div>
        <div style={{ marginLeft: "10px" }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <McButton
              style={{ marginBottom: "10px", padding: "5px", fontSize: "12px" }}
              click={handleModal}
              className="ptask-add-tour-step"
              disabled={lockedFields.find(
                (field) =>
                  field.fieldName === "ptask" &&
                  field.lockedBy !== graphData.username
              )}
            >
              Add/Edit PTasks
            </McButton>
            <IsLocked
              field="ptask"
              lockedFields={lockedFields}
              graphData={graphData}
            />
          </div>
        </div>

        {pTasks && pTasks.length > 0 ? (
          <div className="ptasks-table-tour-step" style={{ marginTop: "12px" }}>
            <McTable data={tableData} columns={PTASK_COLUMNS} fit="small" caption="PTask" />
          </div>
        ) : (
          <div
            className="ptasks-table-tour-step"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "50px",
            }}
          >
            <Typography
              variant="h4"
              style={{ textAlign: "center", color: "grey" }}
            >
              No Tasks Added
            </Typography>
          </div>
        )}
      </div>

      <PTaskModal
        pTasks={pTasks}
        handleModal={handleModal}
        modalOpen={pTaskModal}
        onSave={onSave}
        currentpTasks={currentpTasks}
        setCurrentpTasks={setCurrentpTasks}
      />
      <PhotoUploadModal
        modalOpen={photoModal}
        handleModal={handlePhotoModalClick}
        handleModalClose={handlePhotoModalClose}
        files={images.preventiveCorrectiveMeasures[photosFor]}
        handleFiles={handleFiles}
        fileChange={fileChange}
        hanldePreviewModal={hanldePreviewModal}
        imageToPreview={imageToPreview}
        previewModal={previewModal}
        error={error}
        errorMessage={errorMessage}
        photoFor={photosFor}
      />
    </>
  );
}

export default PTask;
